require('./sectionTemplateBrowser.i18n.json');
require('./sectionTemplateBrowser.tpl.html');
require('./sectionTemplateRepository.js');
require('./sectionTemplateBrowserActionRepository.js');

/*@ngInject*/
const SectionTemplateBrowserController = function ($rootScope, $scope, $timeout, $state, localization, coreConstant, configurationActionsUtil, configurationMediator, databaseDownloadSectionName, navigationStateModel, sectionTemplateAction, modalUtil, userMediator) {

    $scope.viewModel = {
        isLoading: true,
        sectionTemplates: [],
        totalSectionTemplates: 0,
        isGridEmpty: true,
        nameSearchString: '',
        requestParams: {
            key: 'name',
            startIndex: 0,
            pageSize: 25,
            sortType: 'asc'
        },
        shortDateTimeFormat: 'MM/dd/yy hh:mma',
        searchDelayInMilliSeconds: 750
    };

    localization.getTranslationByKey('sectionTemplateBrowser').then(function (translations) {
        $scope.viewModel.recordCountText = _.get(translations, 'recordCountText');
        $scope.viewModel.recordsCountText = _.get(translations, 'recordsCountText');
        $scope.viewModel.nameSearchStringPlaceholder = _.get(translations, 'nameSearchStringPlaceholder');

        $scope.actions = [];
        $scope.context = {
            identifier: 'sectionTemplateBrowser',
            actions: {},
            fallthrough: null,
            model: {
                contextType: coreConstant.CONTEXT_NONE
            }
        };
        $scope.context.actions[coreConstant.CONTEXT_NONE] = '';

        function loadActions() {
            configurationMediator.loadSectionTemplateBrowserActions().then(function (actions) {
                let allActions = [];
                allActions.push({
                    actions: actions.actions,
                    contextType: $scope.context.model.contextType
                });
                $scope.actions = allActions;

                $scope.actionsTimeLastModified = new Date().getTime();
            });
        }

        function loadSectionTemplates() {
            $scope.viewModel.isLoading = true;

            userMediator.restoreViewState('configuration.sectionTemplateBrowser', $scope.viewModel);

            configurationMediator.getSectionTemplatesByName($scope.viewModel.nameSearchString, $scope.viewModel.requestParams).then(function (sectionTemplates) {
                $scope.viewModel.sectionTemplates = sectionTemplates.records;
                $scope.viewModel.totalSectionTemplates = sectionTemplates.totalRecords;
                $scope.viewModel.isGridEmpty = $scope.viewModel.totalSectionTemplates === 0;

                $timeout(function () {
                    $rootScope.$broadcast(coreConstant.event.RECALCULATE_GRID_PAGING);
                    $scope.viewModel.isLoading = false;
                }, 0);
            });
        }

        $scope.getStatus = function (item) {
            const status = item.active ? 'active' : 'inactive';

            return _.get(translations, 'status.' + status);
        };

        $scope.onNameSearchStringChanged = function () {
            $scope.viewModel.startIndex = 0;
            userMediator.saveViewState('configuration.sectionTemplateBrowser', {nameSearchString: $scope.viewModel.nameSearchString});
            loadSectionTemplates();
        };

        $scope.onPagingChange = function ($event, params) {
            $scope.viewModel.requestParams.startIndex = params.startIndex;
            loadSectionTemplates();
        };

        $scope.onSortChange = function (event, params) {
            $scope.viewModel.requestParams.key = params.key;
            $scope.viewModel.requestParams.sortType = params.sortType;
            loadSectionTemplates();
        };

        function resetNavigationState() {
            navigationStateModel.saveViewState('configuration.sectionTemplateBrowser', null);
        }

        $scope.handleAction = function (action, file) {
            if (action.enabled) {
                switch (action.name) {
                    case sectionTemplateAction.NEW_SECTION_TEMPLATE:
                        $state.go('configuration.sectionTemplateEditor.properties', {
                            sectionTemplateId: -1
                        });
                        break;

                    case sectionTemplateAction.BACKUP:
                        configurationActionsUtil.backup(databaseDownloadSectionName.SECTION_TEMPLATES, _.get(translations, 'backup.name'), _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
                        break;

                    case sectionTemplateAction.RELOAD_SECTION_RULES:
                        configurationActionsUtil.reloadSectionTemplateRules();
                        break;

                    default:
                        modalUtil.showActionNotImplementedModal(action.name);
                        break;
                }
            }
        };

        $scope.onClickRow = function (event, item) {
            let navigationModel = {
                parentState: 'configuration.sectionTemplateBrowser',
                currentState: 'configuration.sectionTemplateEditor.properties',
                data: {
                    sectionTemplateId: item.id
                }
            };

            $state.go('configuration.sectionTemplateEditor.properties', {
                sectionTemplateId: item.id
            });

            navigationStateModel.saveViewState('configuration.sectionTemplateBrowser', navigationModel);
        };

        loadActions();
        loadSectionTemplates();
        resetNavigationState();
    });

    $scope.$on(ux.datagrid.events.ON_STARTUP_COMPLETE, function () {
        $scope.$apply();
    });
};

angular.module('ums.configuration')
    .controller('sectionTemplateBrowserController', SectionTemplateBrowserController);
